export const figure7 = {
    chart: {
	type: 'column',
	backgroundColor: 'rgba(255, 255, 255, 0.0)',		   
    },
    title: {
        text: ''
    },
    exporting: {
        enabled: false
    },
    credits: {
        enabled: false
    },
    xAxis: {
        categories: ['العالم', 'آسيا الوسطى وجنوب آسيا', 'شرق آسيا وجنوب شرق آسيا', 'أمريكا اللاتينية ومنطقة البحر الكاريبي', 'أمريكا الشمالية وأوروبا الغربية', 'أوقيانوسيا', 'أفريقيا جنوب الصحراء', 'غربي آسيا وشمال أفريقيا',],
        labels: {
            y: 40,		   style: {
		       textOverflow: 'none'
	       },
        }
    },
    yAxis: {
        allowDecimals: false,
        min: 0,
        max: 80,
        tickInterval: 10,
        title: {
            text: 'النسبة المئوية'
        },
        stackLabels: {
            enabled: true,
            verticalAlign: 'bottom',
            crop: false,
            overflow: 'none',
            y: 20,
            formatter: function () {
                return this.stack;
            },
            style: {
                fontSize: '9px',
                fontWeight: 'normal',
                color: '#6b6a6a'
                
            }
        }
    },
    legend: {
		   enabled: false,
    }, 
    tooltip: {
        formatter: function () {
            var y_value = (this.y / 1).toFixed(1);
            return this.series.userOptions.stack + ', ' + this.x + '<br/>'+ this.series.name + '' + ': <b>' + y_value + ' النسبة المئوية </b>';
        },

    },
    plotOptions: {
        column: {
            stacking: 'normal'
        }
    },

    

    series: [{
		   name: 'انعدام الأمن الغذائي الشديد',
		   showInLegend: false,		   
            color: '#C22E0C',
            data: [7.6, 12.8, 1.1, 7.3, 1.4, 2.6, 19.1, 9.0],
            stack: '2015',

            index: 2

        },
        {
            name: 'انعدام الأمن الغذائي الشديد',
            color: '#C22E0C',
            data: [9.3, 15.8, 1.4, 9.7, 0.9, 3.8, 22.8, 8.8],
            // showInLegend: false,
            stack: '2019',
            linkedTo: ':previous',
            index: 2

        },
         {
            name: 'انعدام الأمن الغذائي الشديد',
            color: '#C22E0C',
            data: [11.7, 20.4, 1.5, 13.9, 1.5, 4.5, 26.6, 10.7],
            // showInLegend: false,
            stack: '2021',
            linkedTo: ':previous',
            index: 2
	 },
	 {
		 name: 'انعدام الأمن الغذائي الشديد',
		       color: '#C22E0C',
		       data: [11.3, 18.8, 1.4, 12.6, 1.5, 3.4, 26.6, 11.1],
	    // showInLegend: false,
		       stack: '2022',
		       linkedTo: ':previous',
		       index: 2
	 },	     
        {
            name: 'انعدام الأمن الغذائي المعتدل',
            color: '#F39200',
            data: [14.2, 14.3, 7.2, 20.0, 8.0, 7.4, 30.7, 19.8],
            stack: '2015',
            
            index: 1

        }, {
            name: 'انعدام الأمن الغذائي المعتدل',
            data: [16.1, 17.8, 8.0, 21.9, 6.2, 9.8, 34.9, 20.6],
            color: '#F39200',
            // showInLegend: false,
            linkedTo: ':previous',
            stack: '2019',
            index: 1
        },
        {
            name: 'انعدام الأمن الغذائي المعتدل',
            data: [17.9, 19.4, 7.8, 26.4, 6.2, 8.5, 39.1, 25.8],
            color: '#F39200',
            // showInLegend: false,
            linkedTo: ':previous',
            stack: '2021',
            index: 1
	},
	{
		name: 'انعدام الأمن الغذائي المعتدل',
		      data: [18.3, 20.6, 7.8, 24.9, 6.6, 9.6, 40.6, 23.0],
		      color: '#F39200',
	    // showInLegend: false,
		      linkedTo: ':previous',
		      stack: '2022',
		      index: 1
	},	     
    ]



};